<template>
  <div :id="id" class="params-editor w-100">
    <div class="row">
      <div v-for="row in mainRows" :key="row.key" class="col-md-6 form-group">
        <label :for="`param-${row.key}`" class="d-block form-label text-left mb-1">{{ row.key }}</label>
        <b-form-checkbox
          v-if="row.kind === 'boolean'"
          :id="`param-${row.key}`"
          :checked="value[row.key]"
          switch
          @change="update(row, $event)"
        />
        <v-select
          v-else-if="row.kind === 'timezone'"
          :id="`param-${row.key}`"
          class="searchable-select"
          :value="value[row.key]"
          :options="timezoneOptionsFor(row)"
          :clearable="false"
          @input="update(row, $event)"
        />
        <input
          v-else
          :id="`param-${row.key}`"
          class="form-control"
          :type="row.kind === 'number' ? 'number' : 'text'"
          step="any"
          :value="value[row.key]"
          v-on="{ [row.kind === 'number' ? 'change' : 'input']: (e) => update(row, e.target.value) }"
        >
        <small v-if="row.hint" class="form-text text-muted">{{ row.hint }}</small>
      </div>
    </div>
    <template v-if="advancedRows.length">
      <b-button variant="outline-primary" size="sm" class="mb-2" @click="showAdvanced = !showAdvanced">
        {{ showAdvanced ? 'Hide advanced' : 'Show advanced' }}
      </b-button>
      <div v-show="showAdvanced" class="row">
        <div v-for="row in advancedRows" :key="row.key" class="col-md-6 form-group">
          <label :for="`param-${row.key}`" class="d-block form-label text-left mb-1">{{ row.key }}</label>
          <b-form-select
            v-if="row.kind === 'operator'"
            :id="`param-${row.key}`"
            :value="value[row.key]"
            :options="operatorOptions"
            @change="update(row, $event)"
          />
          <input
            v-else
            :id="`param-${row.key}`"
            class="form-control"
            type="text"
            readonly
            :value="row.kind === 'raw' ? JSON.stringify(value[row.key]) : value[row.key]"
          >
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  paramRows, setParam, OPERATOR_OPTIONS, timezoneOptions,
} from '@/util/master/paramFields';

export default {
  name: 'ParamsEditor',
  props: {
    value: { type: Object, default: () => ({}) },
    // jenis input diambil dari data GET, bukan dari ketikan user
    original: { type: Object, default: () => ({}) },
    id: { type: String, default: '' },
  },
  data() {
    return { showAdvanced: false, operatorOptions: OPERATOR_OPTIONS };
  },
  computed: {
    rows() {
      return paramRows(this.original);
    },
    mainRows() {
      return this.rows.filter((row) => !row.advanced);
    },
    advancedRows() {
      return this.rows.filter((row) => row.advanced);
    },
  },
  methods: {
    update(row, input) {
      this.$emit('input', setParam(this.value, row, input));
    },
    timezoneOptionsFor(row) {
      return timezoneOptions(this.value[row.key]);
    },
  },
};
</script>

<style scoped>
.searchable-select {
  width: 100%;
}
</style>
